import React, { useEffect, useState } from "react";
import {
  Spin,
  Button,
  Row,
  Space,
  Card,
  Typography,
  Form,
  Modal,
  message,
  Tooltip,
} from "antd";
import { CircleAlert, UserRoundPlus, Users } from "lucide-react";
import { selectRole } from "reducer/login/login-user";
import { useSelector } from "react-redux";
import { FONT, USER_STORAGE, isEspotive } from "constants/index";
import {
  notificationErroInternal,
  notificationInfo,
  notificationSucess,
  notificationSucessMsg,
} from "util/api-utils";
import { ColumnsUser, getUserRowClassName } from "./columns-table";
import { deleteUser, putUser, saveUser } from "services/user/user-service";
import { drawerWidth, listMinWidth } from "util/responsive";
import useBreakpoint from "hooks/useBreakpoint";
import ResponsiveDataList from "components/responsive-data-list";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { resetPassword } from "services/login/login-service";
import DrawerApp from "components/drawer-app";
import UsersDrawerForm from "./users-drawer-form";

dayjs.extend(customParseFormat);
const { Text } = Typography;
const { confirm } = Modal;
const dateFormat = "DD/MM/YYYY";

const UsersClient = ({ users, refreshData, emptyMessage }) => {
  const { isMobile } = useBreakpoint();
  const [loadingDrawer, setLoadingDrawer] = useState(false);
  const [loadingAction, setLoadingAction] = useState(false);
  const [roleRedux, setRoleRedux] = useState(useSelector(selectRole));
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [editId, setEditId] = useState(null);
  const [loadingAvatar, setLoadingAvatar] = useState(false);
  const [imgAvatar, setImgAvatar] = useState("");
  const [typeImg, setTypeImg] = useState("");
  const [changeImage, setChangeImage] = useState(false);
  const [showStepBoot, setShowStepBoot] = useState(false);

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { role } = JSON.parse(localStorageItem);
      if (roleRedux == "" || role != roleRedux) {
        setRoleRedux(role);
      }
    }
  }, [localStorage.getItem(USER_STORAGE)]);

  useEffect(() => {
    const data = users.map((obj) => ({
      ...obj,
      disable: disable,
      edit: edit,
      reset: reset,
      profile:
        obj.role == "ADMIN"
          ? "Administrador"
          : obj.role == "USER_ADMIN"
          ? "Professor"
          : obj.role == "ADMIN_CUSTOMER"
          ? "Cliente"
          : "Aluno",
    }));
    setData(data);
  }, [users]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        setLoadingDrawer(true);
        let functionSave = saveUser;
        values.img = imgAvatar;
        values.typeImage = typeImg;
        values.changeImage = changeImage;
        values.birthDate = values.birthDate.format(dateFormat);

        if (editId !== null) {
          functionSave = putUser;
          values.id = editId;
        }
        functionSave(values)
          .then(() => {
            notificationSucess();
            refreshData();
            onClose();
          })
          .catch((err) => {
            const errorParse = JSON.parse(err.message);
            setLoadingDrawer(false);
            if (errorParse.status == 406) {
              notificationInfo("E-mail já cadastrado");
            } else {
              onClose();
              notificationErroInternal(
                "Aconteceu um erro inesperado, por favor, tente mais tarde."
              );
            }
          });
      })
      .catch((errors) => {
        console.log(errors);
      });
  };

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setTimeout(() => {
      form.resetFields();
    }, 0);
    setEditId(null);
    setImgAvatar("");
    setChangeImage(false);
    setTypeImg("");
    setOpen(false);
    setLoadingDrawer(false);
    setShowStepBoot(false);
  };

  function reset(row) {
    setLoadingAction(true);
    const request = {
      id: row.id,
      password: "uniqueapp",
      shouldReset: true,
    };
    resetPassword(request)
      .then(() => {
        notificationSucessMsg("Senha resetada com sucesso!");
        setLoadingAction(false);
      })
      .catch((err) => {
        setLoadingAction(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde"
        );
      });
  }

  function edit(row) {
    setEditId(row.id);
    setImgAvatar(row.img);
    setShowStepBoot(row.isBoot == true && isEspotive());
    showDrawer();
    form.setFieldsValue({
      name: row.name,
      email: row.email,
      tipeUser: row.role,
      gender: row.gender,
      birthDate: row.birthDate ? dayjs(row.birthDate) : null,
      isBoot: row.isBoot,
      stepBoot1: row.step1,
      stepBoot2: row.step2,
      stepBoot3: row.step3,
      stepBoot4: row.step4,
    });
  }

  function disable(row) {
    confirm({
      title: (
        <div>
          <CircleAlert size={22} style={{ marginBottom: "-5px" }} />
          <span style={{ marginLeft: "10px", fontFamily: FONT }}>
            Tem certeza que deseja deletar o usuário '{row.name}' ?
          </span>
        </div>
      ),
      icon: null,
      okText: "Sim",
      okType: "danger",
      cancelText: "Não",
      onOk() {
        setLoadingAction(true);
        deleteUser(row.id)
          .then(() => {
            notificationSucess();
            setLoadingAction(false);
            refreshData();
          })
          .catch((err) => {
            setLoadingAction(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      },
      onCancel() {},
    });
  }

  function callBackAvatar(imageUrl) {
    setLoadingAvatar(false);
    setImgAvatar(imageUrl);
    setChangeImage(true);
  }

  function handleChangeAvatar(info) {
    if (info.file.status === "uploading") {
      setLoadingAvatar(true);
      return;
    }
    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, (imageUrl) =>
        callBackAvatar(imageUrl)
      );
    }
    if (info.file.status === "error") {
      setLoadingAvatar(false);
      getBase64(info.file.originFileObj, (imageUrl) =>
        callBackAvatar(imageUrl)
      );
    }
  }

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

    if (file.type === "image/jpeg") {
      setTypeImg("jpeg");
    } else if (file.type === "image/png") {
      setTypeImg("png");
    }
    if (!isJpgOrPng) {
      message.error("Você pode enviar apenas imagens JPG/PNG");
    }
    return isJpgOrPng;
  }

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const selectBoot = (value) => {
    const show = value == true;
    const user = data.find((item) => item.id == editId);
    setShowStepBoot(show);
    if (show == true) {
      form.setFieldsValue({
        stepBoot1: user?.step1,
        stepBoot2: user?.step2,
        stepBoot3: user?.step3,
        stepBoot4: user?.step4,
      });
    }
  };

  return (
    <>
      <Spin size="large" spinning={loadingAction}>
        <Row gutter={[24, 24]} style={{ marginLeft: "0px" }}>
          <Space
            direction="vertical"
            size={"small"}
            style={{
              flex: "1 1 500px",
              minWidth: listMinWidth(isMobile),
            }}
          >
            <Card
              id="card-table"
              className="card-table-list"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <Users
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                      Usuários
                    </Text>
                  </div>
                  <Button
                    onClick={showDrawer}
                    style={{ fontFamily: FONT, marginLeft: "10px" }}
                  >
                    <Tooltip style={{ fontFamily: FONT }} title="Novo Usuário">
                      <UserRoundPlus size={20} />
                    </Tooltip>
                  </Button>
                </div>
              }
              bordered={false}
            >
              <ResponsiveDataList
                isMobile={isMobile}
                forceCardLayout
                cardVariant="profile"
                rowKey="id"
                rowClassName={getUserRowClassName}
                columns={ColumnsUser()}
                dataSource={data}
                pagination={{ pageSize: 10, showSizeChanger: false }}
                locale={{
                  emptyText: emptyMessage ?? "Sem registro",
                }}
              />
            </Card>
          </Space>
        </Row>
      </Spin>

      <DrawerApp
        open={open}
        onClose={onClose}
        title={editId ? "Editar Usuário" : "Novo Usuário"}
        body={
          <UsersDrawerForm
            form={form}
            editId={editId}
            roleRedux={roleRedux}
            imgAvatar={imgAvatar}
            loadingAvatar={loadingAvatar}
            loadingDrawer={loadingDrawer}
            showStepBoot={showStepBoot}
            onAvatarChange={handleChangeAvatar}
            beforeUpload={beforeUpload}
            dummyRequest={dummyRequest}
            onSelectBoot={selectBoot}
          />
        }
        size={isMobile ? "default" : "large"}
        width={drawerWidth(isMobile, 65)}
        actionSave={handleOk}
      />
    </>
  );
};
export default UsersClient;
